import { EVENT_LEVELS } from '@/modules/Events/constants';

export default {
  activity: {
    eventCount: '{count} мероприятие | {count} мероприятия | {count} мероприятий',
    organizers: {
      [EVENT_LEVELS.federal]: 'Федеральные организаторы',
      [EVENT_LEVELS.regional]: 'Региональные организаторы',
      [EVENT_LEVELS.municipal]: 'Муниципальные организаторы',
      [EVENT_LEVELS.local]: 'Локальные организаторы',
    },
  },
  memberForm: {
    requiredRemaining: 'Заполните все обязательные данные',
    requiredFields: 'Поля: {count}',
    requiredDocuments: 'Документы: {count}',
  },
  documents: {
    fileLimit: 'Можно загрузить не более {count} файла | Можно загрузить не более {count} файлов | Можно загрузить не более {count} файлов',
  },
  level: {
    event: {
      [EVENT_LEVELS.federal]: 'федеральное | федеральные | федеральные',
      [EVENT_LEVELS.municipal]: 'муниципальное | муниципальные | муниципальные',
      [EVENT_LEVELS.regional]: 'региональное | региональные | региональные',
      [EVENT_LEVELS.local]: 'локальное | локальные | локальные',
    },
    stage: {
      [EVENT_LEVELS.federal]: 'федеральный | федеральных | федеральных',
      [EVENT_LEVELS.municipal]: 'муниципальный | муниципальных | муниципальных',
      [EVENT_LEVELS.regional]: 'региональный | региональных | региональных',
      [EVENT_LEVELS.local]: 'локальный | локальных | локальных',
    },
    plural: {
      [EVENT_LEVELS.federal]: 'федерального',
      [EVENT_LEVELS.municipal]: 'муниципального',
      [EVENT_LEVELS.regional]: 'регионального',
      [EVENT_LEVELS.local]: 'локального',
    },
  },
};
